<template>
  <notifications
    :notifications="notifications"
    :is-loading="isLoading"
    :is-open="isListOpen"
    :mode="mode"
    :n-unread="nUnread"
    :has-more="hasMore"
    @set-is-open="setIsListOpen"
    @toggle-mode="toggleMode"
    @ack-all="ack({ all: true })"
    @ack-one="ack({ notification_id: $event })"
    @load-more="load"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Notifications from '../components/Notifications.vue'

export default {
  components: {
    Notifications,
  },
  computed: {
    ...mapGetters('notification', ['nUnread', 'notifications', 'isLoading', 'isListOpen', 'mode', 'hasMore']),
  },
  methods: {
    ...mapActions('notification', ['setIsListOpen', 'toggleMode', 'ack', 'load']),
  },
}
</script>
